// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-gitlab"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 2H5.5L1.5 14L12 22L22.5 14L18.5 2H18L15.5 9.33333H8.5L6 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 2H5.5L1.5 14L12 22L22.5 14L18.5 2H18L15.5 9.33333H8.5L6 2Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoGitlabIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-gitlab',
    ref,
    icon: element,
  },
));

LogoGitlabIcon.displayName = 'LogoGitlabIcon';

export default LogoGitlabIcon;
